@if (userBlockIsVisible()) {
  <div class="item user-block">
    <div class="user-block-info">
      <span class="user-block-name"
        >{{ user?.firstName }} {{ user?.lastName }}</span
        >
        <span class="user-block-role">{{
          findUserRoleDescription(user?.roles)
        }}</span>
      </div>
    </div>
  }
